import React from 'react';


import {
    Button,
    Flash,
    Form,
    FormSection,
    FormField,
    Input,
    TableFiltering,
    Table,
    TablePagination,
    Modal,
    Spinner

} from 'AWS-UI-Components-React';

import {
    JSClient,
    Header
} from '../common';

export const COLUMN_DEFINITIONS = [{
    id: 'uuid',
    header: () => 'ID',
    cell: (item) => item.uuid,
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'user',
    header: () => 'User',
    cell: (item) => item.user,
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'type',
    header: () => 'Activity Type',
    cell: (item) => item.taskType,
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'date',
    header: () => 'Activity Date',
    cell: (item) => (new Date(parseInt(item.activityDate))).toLocaleString(),
    minWidth: '100px',
    allowLineWrap: false
}, {
    id: 'meta',
    header: () => 'Metadata',
    cell: (item) => {
        return <a href={item.metadata} target="_blank">Invoice Link</a>;
    },
    minWidth: '100px',
    allowLineWrap: false
}];

export class TaskTable extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            unknownloaderror: false,
            initialLoadDone: false,
            user: "",
            taskLoadDone: false,
            tasks: [],
            addBeerOpen: false,
            props: JSON.parse(JSON.stringify(this.props))
        };
        this.clientLoaded = this.clientLoaded.bind(this);
        this.showAddModal = this.showAddModal.bind(this);
        this.hideAddModal = this.hideAddModal.bind(this);
        this.saveBeer = this.saveBeer.bind(this);
        this.getTasksResultHandler = this.getTasksResultHandler.bind(this);
    }

    clientLoaded() {
        this.client.getIdentity(identityResult => {
            this.setState({...this.state, user: identityResult.username, initialLoadDone: true});
            this.client.getTasks({
                type: this.state.type,
                user: this.state.user, ...this.props
            }, this.getTasksResultHandler);
        });
    }

    componentWillMount() {
        this.client = new JSClient({onReady: this.clientLoaded});
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (!objectCompare(this.state.props, nextProps)) {
            this.setState({...this.state, props: JSON.parse(JSON.stringify(nextProps)), taskLoadDone: false});
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (!nextState.taskLoadDone)
            this.client.getTasks({
            type: nextState.type,
            user: nextState.user, ...nextProps
        }, this.getTasksResultHandler);
    }

    getTasksResultHandler(taskResult) {
        this.setState({tasks: taskResult.tasks, taskLoadDone: true});
    }

    headerCounter(items) {
        return items.length;
    }

    showAddModal() {
        this.setState({addBeerOpen: true});
    }

    hideAddModal() {
        this.setState({addBeerOpen: false});
    }

    saveBeer() {
        this.hideAddModal();
        const s = this;
        this.client.postBeer(function (response) {
            s.client.getBeers(s.getBeersResultHandler);
        }, null, document.getElementById('beerNameInput').value, null);
    }


    render() {
        if (!this.state.initialLoadDone) {
            return (<div className='offset-xxs-1 col-s-8 offset-l-2 col-xl-3'><Spinner/></div>)
        }
        return (
                <div>
                        <Table
                            columnDefinitions={COLUMN_DEFINITIONS}
                            loading={!this.state.taskLoadDone}
                            resizableColumns={true}
                            header={(
                                <Header
                                    title="Tasks"
                                    counter={this.headerCounter(this.state.tasks)}
                                />
                            )}
                            items={this.state.tasks}
                            empty={<div className="awsui-util-t-c">
                                <div className="awsui-util-pt-l awsui-util-mb-l">
                                    <b>{"No tasks found!!"}</b>
                                </div>
                            </div>}
                        >
                            <TableFiltering
                                filteringPlaceholder="Find Tasks"
                                filteringText=""
                                filteringCountTextFunction={count => `${count} ${count === 1 ? 'match' : 'matches'}`}
                            />
                            <TablePagination/>

                        </Table>
                </div>
        );
    }
}

function objectCompare(a, b) {
    return JSON.stringify(a) === JSON.stringify(b)
}


// WEBPACK FOOTER //
// ./src/components/tables/task_table.jsx